import logo from './assets/logo.png';

const EndCover = () => {
    const contacts = [
        {name: 'John Kasey, MHA', email: 'John.Kasey@milliman.com'},
        {name: 'Stefany Ross, MHA', email: 'Stefany.Ross@milliman.com'},
        {name: 'Gordon Chan, MHA', email: 'Gordon.Chan@milliman.com'},
        {name: 'Adam Hearn, MS-DSPP', email: 'Adam.Hearn@milliman.com'}
    ];
    return (
        <article className="end-cover">
            <div className='info-section'>
                <h2>Solutions for a world at risk™</h2>
                <div>
                    <div className="about-milliman">
                        <p>Milliman leverages deep expertise, actuarial rigor, and advanced
                            technology to develop solutions for a world at risk. We help
                            clients in the public and private sectors navigate urgent, complex
                            challenges—from extreme weather and market volatility to
                            financial insecurity and rising health costs—so they can meet
                            their business, financial, and social objectives. Our solutions
                            encompass insurance, financial services, healthcare, life
                            sciences, and employee benefits. Founded in 1947, Milliman is
                            an independent firm with offices in major cities around the globe.
                        </p>
                        <p>
                            <a href="https://www.milliman.com" target='_blank' rel="noreferrer">milliman.com</a>
                        </p>
                    </div>
                    {/* <div className="contact">
                        <h4>CONTACT</h4>
                        {contacts.map((contact) => {
                            const {name, email} = contact;
                            return (
                                <div key={email} className='name-email'>
                                    <p>{name} </p>
                                    <p>
                                        <a href={`mailto:${email}`}>
                                            {email}
                                        </a>
                                    </p>
                                </div>
                            );
                        })}
                    </div> */}
                </div>
            </div>
            <div className="logo">
                <img src={logo} alt="Milliman Logo" />
            </div>
            <p className="copyright-info">
                © 2025 Milliman, Inc. All Rights Reserved. The materials in this document represent the opinion of the authors and are not representative of the views of Milliman, Inc.
                Milliman does not certify the information, nor does it guarantee the accuracy and completeness of such information. Use of such information is voluntary and should not be
                relied upon unless an independent review of its accuracy and completeness has been performed. Materials may not be reproduced without the express consent of Milliman.
            </p>
        </article>
    );
};

export default EndCover;
